import { Box, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { BreadCrumb } from "../../../../../../components"
import { useTranslation } from "react-i18next"
import { CustomPaper } from "../../../../../../components/CustomPaper"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import { useGeneralConfigContext } from "../../context"
import { useLayoutEffect, useMemo } from "react"
import { useInputForm } from "../../utils"
import { generalDisabled } from "../../../../../../utils/validate/validate"
import { useMutation } from "@tanstack/react-query"
import { emitEvent } from "../../../../../../hooks/emitter"
import { Events } from "../../../../../../hooks/emitter/types"
import { Types } from "../../../../../../utils/enums"
import { LoadingButton } from "@mui/lab"
import { configServices } from "../../../../../../utils/constants/callService"
import { ConfigBody } from "../../../../../../service/serviceAreaDepartment/body"
import { Item } from "../../../../../../utils/types/generals"

export function Form() {
    const inputForm = useInputForm()
    const { inputForm: { input, setInput }, formData, service, setItem } = useGeneralConfigContext()
    const { t } = useTranslation()
    const styles = useStyles()
    const diabledBtn = useMemo(() => {
        const isGeneralDisabled = generalDisabled(input, formData.filterData)
        const existSomeRequest = !!formData.filterData?.preventiveCatalog?.value && !!formData.filterData?.correctiveCatalog?.value
        return isGeneralDisabled || !existSomeRequest
    }, [input, formData.filterData])
    const emits = useMemo(() => ({
        success: ({ message }: { message: string }) => { emitEvent(Events.snackbar, { open: true, type: Types.SUCCESS, message }) },
        error: ({ message }: { message: string }) => { emitEvent(Events.snackbar, { open: true, type: Types.ERROR, message }) },
    }), [])
    const config = useMutation({
        mutationFn: configServices.createConfig,
        onSuccess: (data) => {
            if (!data.errors) {
                emits.success({ message: t(`general.service.areaDepartment.form.snackbar.config.create.success`) })
                formData.cleanFilter()
                setInput(prev => ({ ...prev, departments: { ...prev.departments, items: [] } }))
                return
            }
            emits.error({ message: t(`general.service.areaDepartment.form.snackbar.config.create.error`) })
        },
        onError: () => {
            emits.error({ message: t(`general.service.areaDepartment.form.snackbar.config.create.error`) })
        }
    })
    const submit = () => {
        const { departments, preventiveCatalog, correctiveCatalog } = formData.filterData
        const body: ConfigBody = {
            departments: departments.map((department: Item) => department.value),
            ...!!correctiveCatalog?.value && { correctiveCatalogId: correctiveCatalog.value },
            ...!!preventiveCatalog?.value && { preventiveCatalogId: preventiveCatalog.value }
        }
        config.mutate({ body })
    }
    useLayoutEffect(() => {
        setItem({})
        setInput(inputForm)
        service.getAreasFilterService()
        service.getCatalogList()
    }, [])

    return (
        <Box className="main-container">
            <Box sx={styles.center}>
                <Box sx={styles.form}>
                    <BreadCrumb
                        removeBreadcrumb={['organization-chart']}
                        replaceLabels={{
                            form: 'area-department-create',
                            formEdit: 'area-department-edit',
                            'organization-area-department': 'area-department-config'
                        }}
                    />

                    <Typography variant="subtitle_grey" color='secondary.main' fontWeight='bold'>{t(`general.service.areaDepartment.form.titleCreate`)}</Typography>

                    <CustomPaper sx={styles.container}>
                        <DinamicForm input={Object.values(input)} onChange={formData.onChange} values={formData.filterData} spacing={{ row: 3, column: 3 }} />

                        <Box sx={styles.footer}>
                            <LoadingButton loading={config.isPending} onClick={submit} disabled={diabledBtn} variant="contained">{t('general.continue')}</LoadingButton>
                        </Box>
                    </CustomPaper>
                </Box>
            </Box>
        </Box>
    )
}